import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { BASE_URL, API, ESTADOS_OPORTUNIDAD, OPORTUNIDADES_STATE_SECTION_MAP } from 'CONST';
import { get } from 'helpers/requests';
import PageContainer from '../PageContainer';
import CrearOportunidadSection from './CrearOportunidadSection';
import AsignarSuscriptorSection from './AsignarSuscriptorSection';
import OportunidadesFormAccordion from './OportunidadesFormAccordion';
import InformacionInicialSection from './InformacionInicialSection';
import ValidarInformacionInicialSection from './ValidarInformacionSection';
import CompletarInformacionSection from './CompletarInformacionSection';
import RevisionGenericSection from './RevisionGenericSection';
import ExposicionMaximaSection from './ExposicionMaximaSection';
import OportunidadRechazadaSection from './OportunidadRechazadaSection';
import CargarContrafianzaSection from './CargarContrafianzaSection';
import EmitirLineaSection from './EmitirLineaSection';
import OportunidadEmitidaSection from './OportunidadEmitidaSection';
import WarningModal from '../UI/WarningModal';

const OportunidadesForm = () => {
  const { id } = useParams();
  const history = useHistory();
  const [nameBreadcrumb, setNameBreadcrumb] = useState('CREAR OPORTUNIDAD');
  const [estadosOportunidad, setEstadosOportunidad] = useState([]);
  const [observaciones, setObservaciones] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [edit, setEdit] = useState(true);
  const [fullData, setFullData] = useState({});
  const [errorModal, setErrorModal] = useState(false);
  const [initialSection, setInitialSection] = useState(0);
  const reg = new RegExp('^[0-9]*$');

  useEffect(() => {
    if (id !== undefined) {
      setEdit(true);
      if (reg.test(id)) {
        get(`${BASE_URL}${API.oportunidadesLinea}${id}`)
          .then((response) => {
            setFullData(response);
            setInitialSection(OPORTUNIDADES_STATE_SECTION_MAP[response.estado.nemotecnico]);
            setLoaded(true);
          })
          .catch((error) => {
            if (error.status === 404) {
              setErrorModal(true);
            }
          });
      } else {
        setErrorModal(true);
      }
    } else {
      setEdit(false);
      setLoaded(true);
    }
    get(`${BASE_URL}${API.estadosOportunidad}`).then((response) => {
      setEstadosOportunidad(response.results);
    });
  }, []);

  useEffect(() => {
    if (id) {
      setNameBreadcrumb('EDITAR OPORTUNIDAD');
      if (reg.test(id)) {
        get(`${BASE_URL}${API.observacionesOportunidad}?oportunidad=${id}`).then((response) => {
          setObservaciones(response);
        });
      }
    }
  }, [fullData]);

  const sections = [
    {
      name: 'Crear Oportunidad',
      component: <CrearOportunidadSection fullData={fullData} edit={edit} id={id} />,
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Responsable de la Oportunidad',
      isVisible: true,
    },
    {
      name: 'Asignar Suscriptor',
      component: (
        <AsignarSuscriptorSection
          fullData={fullData}
          setFullData={setFullData}
          setInitialSection={setInitialSection}
          estadosOportunidad={estadosOportunidad}
          id={id}
        />
      ),
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Responsable de la Oportunidad',
      isVisible: true,
    },
    {
      name: 'Información Inicial',
      component: (
        <InformacionInicialSection
          fullData={fullData}
          estadosOportunidad={estadosOportunidad}
          observaciones={observaciones}
          id={id}
        />
      ),
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Responsable de la Oportunidad',
      isVisible: true,
    },
    {
      name: 'Validar Información Inicial',
      component: (
        <ValidarInformacionInicialSection
          fullData={fullData}
          setFullData={setFullData}
          setInitialSection={setInitialSection}
          estadosOportunidad={estadosOportunidad}
          observaciones={observaciones}
          id={id}
        />
      ),
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Suscriptor',
      isVisible: true,
    },
    {
      name: 'Completar Información Oportunidad',
      component: (
        <CompletarInformacionSection
          fullData={fullData}
          setFullData={setFullData}
          setInitialSection={setInitialSection}
          estadosOportunidad={estadosOportunidad}
          id={id}
        />
      ),
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Suscriptor',
      isVisible: true,
    },
    {
      name: 'Revisar Condiciones Suscripción',
      component: (
        <RevisionGenericSection
          fullData={fullData}
          estadosOportunidad={estadosOportunidad}
          observaciones={observaciones}
          id={id}
          revisor={0}
        />
      ),
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Suscriptor',
      isVisible: true,
    },
    {
      name: 'Revisar Condiciones Riesgo',
      component: (
        <RevisionGenericSection
          fullData={fullData}
          estadosOportunidad={estadosOportunidad}
          observaciones={observaciones}
          id={id}
          revisor={1}
        />
      ),
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Área de Riesgo',
      isVisible:
        fullData &&
        fullData.estado_suscriptor_riesgo_comite &&
        [
          ESTADOS_OPORTUNIDAD.informacionCompletadaEsperandoRiesgo,
          ESTADOS_OPORTUNIDAD.informacionCompletadaEsperandoComite,
        ].includes(fullData.estado_suscriptor_riesgo_comite.nemotecnico),
    },
    {
      name: 'Revisar Condiciones Comité',
      component: (
        <RevisionGenericSection
          fullData={fullData}
          estadosOportunidad={estadosOportunidad}
          observaciones={observaciones}
          id={id}
          revisor={2}
        />
      ),
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Comité de Riesgo',
      isVisible:
        fullData &&
        fullData.estado_suscriptor_riesgo_comite &&
        [ESTADOS_OPORTUNIDAD.informacionCompletadaEsperandoComite].includes(
          fullData.estado_suscriptor_riesgo_comite.nemotecnico,
        ),
    },
    {
      name: 'Exposición máxima',
      component: (
        <ExposicionMaximaSection
          fullData={fullData}
          estadosOportunidad={estadosOportunidad}
          observaciones={observaciones}
          id={id}
        />
      ),
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Responsable de la Oportunidad',
      isVisible: !(
        fullData &&
        fullData.estado &&
        [ESTADOS_OPORTUNIDAD.rechazado].includes(fullData.estado.nemotecnico)
      ),
    },
    {
      name: 'Rechazado',
      component: (
        <OportunidadRechazadaSection
          fullData={fullData}
          estadosOportunidad={estadosOportunidad}
          observaciones={observaciones}
          id={id}
        />
      ),
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Responsable de la Oportunidad',
      isVisible:
        fullData &&
        fullData.estado &&
        [ESTADOS_OPORTUNIDAD.rechazado].includes(fullData.estado.nemotecnico),
    },
    {
      name: 'Cargar Contrafianza',
      component: (
        <CargarContrafianzaSection
          fullData={fullData}
          estadosOportunidad={estadosOportunidad}
          observaciones={observaciones}
          id={id}
        />
      ),
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Área de Riesgo',
      isVisible: true,
    },
    {
      name: 'Emitir Línea',
      component: (
        <EmitirLineaSection
          fullData={fullData}
          estadosOportunidad={estadosOportunidad}
          observaciones={observaciones}
          id={id}
        />
      ),
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Suscriptor',
      isVisible: true,
    },
    {
      name: 'Oportunidad Línea Emitida',
      component: <OportunidadEmitidaSection />,
      collapsed: true,
      isValid: true,
      expansible: true,
      responsable: 'Responsable: Suscriptor',
      isVisible: true,
    },
  ];
  sections[initialSection].isValid = false;
  sections[initialSection].collapsed = false;

  return (
    <PageContainer
      breadcrumbs={[
        { id: 0, name: 'RIESGO', url: '/' },
        { id: 1, name: 'GARANTÍA', url: '/garantia' },
        { id: 2, name: 'OPORTUNIDADES', url: '/garantia/oportunidades' },
        { id: 3, name: nameBreadcrumb },
      ]}
    >
      {loaded && (
        <OportunidadesFormAccordion
          sections={sections.slice(0, initialSection + 1)}
          openSection={initialSection}
        />
      )}
      <WarningModal
        isOpen={errorModal}
        toggle={() => setErrorModal(false)}
        handleClearError={() => {
          setErrorModal(false);
          history.push('/garantia/oportunidades');
        }}
        errorMsg="Oportunidad no encontrada."
      />
    </PageContainer>
  );
};

export default OportunidadesForm;
